import { blumarWebserviceAxios } from "./HttpHelper";
import moment from "moment";

let axios = blumarWebserviceAxios();

export default class PaymentService {
  constructor() {
    this.url = "/payment-webservice";
  }

  getCities(stateId) {
    return axios.get(`${this.url}/states/${stateId}/cities`);
  }

  getStates() {
    return axios.get(`${this.url}/states`);
  }

  getCountries() {
    return axios.get(`${this.url}/countries`)
  }

  generateBankTicket(bankTicket) {
    if(!bankTicket.dueDate) bankTicket.dueDate = bankTicketDueDate();
    return axios.post(this.url + "/bank-tickets", bankTicket);
  }

  getBankTicketDocument(id, payerName) {
    let encodedPayerName = base64UrlEncode(payerName);
    return axios.get(this.url + `/bank-tickets/${id}/document/${encodedPayerName}`, {responseType: 'arraybuffer'});
  }

	authorize(sale) {
    return axios.post(this.url + "/credit-card/sales", {...sale});
  }
}

function bankTicketDueDate() {
  let today = moment();
  let SATURDAY = 6, SUNDAY = 7, weekday = today.isoWeekday();
  let postponedDays = 3;
  if (weekday === SATURDAY || weekday === SUNDAY)
    postponedDays = postponedDays + (SUNDAY - weekday + 1);
  return today.add(postponedDays, 'days').format('DD/MM/YYYY');
}

function base64UrlEncode(str) {
  return btoa(unescape(encodeURIComponent(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}



// WEBPACK FOOTER //
// ./src/services/PaymentService.js